import { section } from "@/neon";

import carousel from "@/components/carousel";
import { animateFeaturedCollectionRow } from "@/lib/animation";

const selectors = {
  carouselContainer: ".featured-collection-row__slides",
};

section("featured-collection-row", {
  onLoad() {
    this.carouselContainer = this.container.querySelector(
      selectors.carouselContainer
    );

    this.carousel = carousel(this.container);

    this.animateFeaturedCollectionRow = animateFeaturedCollectionRow(
      this.container
    );
  },

  onBlockSelect({ target: slide }) {
    this.carousel.goToSlide(slide.dataset.index);
  },

  onUnload() {
    this.carousel.unload();

    this.animateFeaturedCollectionRow?.destroy();
  },
});
